<template>
    <el-dialog class="el-dialogs" :title="title" width="600px" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent
                 label-width="90px">
            <el-form-item label="专题名称" prop="thematicName">
                <el-input v-model.trim="searchForm.thematicName" maxlength="20"
                          placeholder="请输入专题名称(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="thematicState">
                <div class="flex_l_c">
                    <el-switch
                            v-model="searchForm.thematicState"
                            active-value="1"
                            inactive-value="0">
                    </el-switch>
                    <div style="font-size: 12px;color: #C0C0C0;padding-left: 10px">
                        启用后，还需要在【分类索引管理】中添加并公开，才能应用于资源。
                    </div>
                </div>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "addSpecial",
    data() {
        return {
            title: '新增专题',
            visible: false,
            seleData: {},
            searchForm: {
                id: '',
                thematicName: '',
                thematicState: '0',
            },
            rules: {
                thematicName: [
                    {required: true, message: '请输入专题名称', trigger: 'blur'}
                ],
            },
        }
    },

    methods: {
        init(row) {
            this.seleData = {}
            this.searchForm = {
                thematicName: '',
                thematicState: '0',
            }
            if (row) {
                this.title = '编辑专题'
                this.seleData = row
                this.getDatail()
            } else {
                this.title = '新增专题'
            }
            this.visible = true
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
        },

        getDatail() {
            this.$axios(this.api.academic.thematicGetById + this.seleData.id, {}).then(data => {
                if (data && data.status) {
                    this.searchForm = data.data
                }
            })
        },

        //提交
        doSubmit() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    if (this.seleData.id) {
                        this.$axios(this.api.academic.thematicUpdateById, this.searchForm, 'put').then(data => {
                            if (data && data.status) {
                                this.$message.success('修改成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        this.$axios(this.api.academic.thematicSave, this.searchForm, 'post').then(data => {
                            if (data && data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refresh')
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
.el-dialogs >>> .el-dialog__body {
    height: auto !important;
}
</style>